// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__1QS4K","header":"Messages_header__2nLHw"};